import React from 'react';
import { 
  Star, 
  Calculator, 
  Search, 
  Plus, 
  BarChart3, 
  Filter,
  TrendingUp,
  Users,
  Award,
  Clock
} from 'lucide-react';

// Composant d'en-tête pour les évaluations de soutenance
const EvaluationHeader = ({
  searchTerm,
  onSearchChange,
  onAddNew,
  filters,
  onFilterChange,
  soutenances,
  criteres,
  stats
}) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 mb-6 overflow-hidden">
      {/* Header principal */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="bg-white/20 p-2 rounded-lg">
              <Star className="h-6 w-6 text-white" />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-white">Évaluations de Soutenance</h2>
              <p className="text-blue-100 text-sm">Gestion des évaluations et critères</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <button
              onClick={onAddNew}
              className="bg-white hover:bg-gray-50 text-blue-600 px-4 py-2 rounded-lg flex items-center space-x-2 transition-colors font-medium"
            >
              <Plus className="h-4 w-4" />
              <span>Nouvelle Évaluation</span>
            </button>
          </div>
        </div>
      </div>

      {/* Barre de recherche et filtres */}
      <div className="px-6 py-4 border-b border-gray-100">
        <div className="flex flex-col md:flex-row gap-4">
          {/* Barre de recherche */}
          <div className="flex-1">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
              <input
                type="text"
                placeholder="Rechercher une évaluation..."
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
              />
            </div>
          </div>

          {/* Filtres rapides */}
          <div className="flex items-center space-x-3">
            <select
              value={filters.critere || ''}
              onChange={(e) => onFilterChange({ ...filters, critere: e.target.value })}
              className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
            >
              <option value="">Tous les critères</option>
              {criteres.map(critere => (
                <option key={critere.id} value={critere.id}>{critere.nom}</option>
              ))}
            </select>
            
            <select
              value={filters.evaluateur_type || ''}
              onChange={(e) => onFilterChange({ ...filters, evaluateur_type: e.target.value })}
              className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
            >
              <option value="">Tous les évaluateurs</option>
              <option value="interne">Évaluateurs internes</option>
              <option value="externe">Évaluateurs externes</option>
            </select>
          </div>
        </div>
      </div>

      {/* Statistiques */}
      {stats && (
        <div className="px-6 py-4 bg-gray-50">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="bg-white p-4 rounded-lg border border-gray-200">
              <div className="flex items-center space-x-3">
                <div className="bg-blue-100 p-2 rounded-lg">
                  <Calculator className="h-5 w-5 text-blue-600" />
                </div>
                <div>
                  <p className="text-sm text-gray-600">Total Évaluations</p>
                  <p className="text-2xl font-bold text-gray-900">{stats.nbEvaluations || 0}</p>
                </div>
              </div>
            </div>

            <div className="bg-white p-4 rounded-lg border border-gray-200">
              <div className="flex items-center space-x-3">
                <div className="bg-green-100 p-2 rounded-lg">
                  <TrendingUp className="h-5 w-5 text-green-600" />
                </div>
                <div>
                  <p className="text-sm text-gray-600">Moyenne Générale</p>
                  <p className="text-2xl font-bold text-gray-900">
                    {stats.moyenne ? stats.moyenne.toFixed(2) : '0.00'}/20
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-4 rounded-lg border border-gray-200">
              <div className="flex items-center space-x-3">
                <div className="bg-blue-100 p-2 rounded-lg">
                  <Users className="h-5 w-5 text-blue-600" />
                </div>
                <div>
                  <p className="text-sm text-gray-600">Note Maximale</p>
                  <p className="text-2xl font-bold text-gray-900">
                    {stats.max ? stats.max.toFixed(1) : '0.0'}/20
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-4 rounded-lg border border-gray-200">
              <div className="flex items-center space-x-3">
                <div className="bg-yellow-100 p-2 rounded-lg">
                  <Award className="h-5 w-5 text-yellow-600" />
                </div>
                <div>
                  <p className="text-sm text-gray-600">Note Minimale</p>
                  <p className="text-2xl font-bold text-gray-900">
                    {stats.min ? stats.min.toFixed(1) : '0.0'}/20
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EvaluationHeader; 